import Vue from "vue";

window.Vue = require('vue');

/* dashboard */

Vue.component('planning-form-request-user', require('./components/dashboard/Calendars/PlanningFormRequestUser.vue').default);
Vue.component('planning-form-request', require('./components/dashboard/Calendars/PlanningFormRequest.vue').default);
Vue.component('planning-form-request-modal', require('./components/dashboard/Calendars/PlanningFormRequestModal.vue').default);

Vue.component('planning-assembly', require('./components/dashboard/Calendars/PlanningAssembly.vue').default);
Vue.component('planning-assembly-modal', require('./components/dashboard/Calendars/PlanningAssemblyModal.vue').default);
Vue.component('planning-transport', require('./components/dashboard/Calendars/PlanningTransport.vue').default);
Vue.component('planning-transport-modal', require('./components/dashboard/Calendars/PlanningTransportModal.vue').default);
Vue.component('planning-production', require('./components/dashboard/Calendars/PlanningProduction.vue').default);
Vue.component('planning-production-modal', require('./components/dashboard/Calendars/PlanningProductionModal.vue').default);
Vue.component('planning-service', require('./components/dashboard/Calendars/PlanningService.vue').default);
Vue.component('planning-service-modal', require('./components/dashboard/Calendars/PlanningServiceModal.vue').default);

Vue.component('conversations', require('./components/dashboard/Conversations.vue').default);
Vue.component('conversation-show-from-offer-modal', require('./components/dashboard/ConversationsShowFromOfferModal.vue').default);
Vue.component('conversation-modal', require('./components/dashboard/Modals/ConversationModal.vue').default);
Vue.component('new-conversation-modal', require('./components/dashboard/Modals/NewConversationModal.vue').default);
Vue.component('new-conversation-from-offer-modal', require('./components/dashboard/Modals/NewConversationFromOfferModal.vue').default);
Vue.component('add-users-to-conversation-modal', require('./components/dashboard/Modals/AddUsersToConversationModal.vue').default);
Vue.component('add-attachment-to-conversation-modal', require('./components/dashboard/Modals/AddAttachmentToConversationModal.vue').default);
Vue.component('archived-conversations-modal', require('./components/dashboard/Modals/ArchivedConversationsModal.vue').default);
Vue.component('add-offer-to-conversation-modal', require('./components/dashboard/Modals/AddOfferToConversationModal.vue').default);

Vue.component('todos', require('./components/dashboard/Todos.vue').default);
Vue.component('offers', require('./components/dashboard/Offers.vue').default);
Vue.component('stale-assemblies', require('./components/dashboard/StaleAssemblies.vue').default);

Vue.component('general-statistics', require('./components/dashboard/GeneralStatistics.vue').default);
Vue.component('general-statistics-small', require('./components/dashboard/GeneralStatisticsSmall.vue').default);
Vue.component('present-employees', require('./components/dashboard/PresentEmployees.vue').default);
Vue.component('link-user-employees-modal', require('./components/dashboard/Modals/LinkUserEmployeesModal.vue').default);
Vue.component('new-message-notification-modal', require('./components/dashboard/Modals/NewMessageNotificationModal.vue').default);
Vue.component('potential-dealers', require('./components/dashboard/PotentialDealers.vue').default);
Vue.component('production-statistics', require('./components/dashboard/ProductionStatistics.vue').default);
Vue.component('unpaid-invoices', require('./components/dashboard/UnpaidInvoices.vue').default);
Vue.component('open-assemblies', require('./components/dashboard/OpenAssemblies.vue').default);

Vue.component('birthdays', require('./components/dashboard/Birthdays.vue').default);
Vue.component('reviews', require('./components/dashboard/Reviews.vue').default);
Vue.component('announcements', require('./components/dashboard/Announcements.vue').default);
Vue.component('announcement-modal', require('./components/dashboard/Modals/AnnouncementModal.vue').default);
Vue.component('announcement-view-modal', require('./components/dashboard/Modals/AnnouncementViewModal.vue').default);
Vue.component('announcement-archived-modal', require('./components/dashboard/Modals/AnnouncementArchivedModal.vue').default);

Vue.component('unread-message-counter', require('./components/dashboard/UnreadMessageCounter.vue').default);

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/** workaround fpm caching */
// axios.interceptors.request.use(config => {
//     config.params = config.params || {};
//     config.params._ts = Date.now();
//     return config;
// });

window._ = require('lodash');

window.moment = require('moment');

import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

const app = new Vue({
    el: '#app',
});

const modals = new Vue({
    el: '#dashboard-modals',
});

// Mount Vue in the sidebar so components like <unread-message-counter> can render there
const sidebarApp = new Vue({
    el: '#sidebar',
});
